<sn-icon-button
  *ngIf="dismissible"
  type="button"
  class="close"
  aria-label="Close"
  (click)="close()"
>
  <sn-icon aria-hidden="true">close</sn-icon>
</sn-icon-button>
<ng-content></ng-content>
